<!--Advantage:优势 2021/03/29 12:27:36 Sunanguang-->

<template>
   <div class="its-advantage">
     <ts-page-layout center>
      <p class="its-advantage-title">五大方案优势 打造智慧教学闭环</p>
      <div class="its-advantage-list">
        <div v-for="(item, i) in advantages" :key="'advantage-' + i" class="its-advantage-item"
          :class="['its-advantage-item-'+ item.id, item.hover ? 'its-advantage-item-big' : '']"
          @mouseenter="item.hover=true" @mouseleave="item.hover=false">
          <p>{{item.title}}</p>
          <p>{{item.subTitle}}</p>
          <div v-if="item.hover" class="its-cover">
            <p v-if="item.id === 4" v-html="item.title + '<br>'  + item.subTitle">{{ + item.subTitle}}</p>
            <p v-else-if="item.id !== 2">{{item.title}} {{item.subTitle}}</p>
            <p v-else>{{item.title + item.subTitle}}</p>
            <p style="text-align:left;margin-top:25px;font-size: 20px" v-html="item.desc"></p>
          </div>
        </div>
      </div>
     </ts-page-layout>
   </div>
</template>
<script>
export default {
  name: 'Advantage',
  data () {
    return {
      advantages: [
        {
          id: 1,
          title: '优质资源',
          subTitle: '随取随用',
          hover: false,
          desc: '教学资源覆盖K12全学科、全学段，如课件、教案学案、素材、视频、试题、试卷等。'
        },
        {
          id: 2,
          title: '教学全流程',
          subTitle: '覆盖',
          hover: false,
          desc: '在线轻松备课，智能高效授课，预习训练一键收发，教学设计有方，学生自主学习，成绩精准提高。'
        },
        {
          id: 3,
          title: '英语专业教研',
          subTitle: '学科特色保障',
          hover: false,
          desc: '英语学科特色内容题库支持按语言能力场景高效选择，听说读写特色练习，口语精准测评。'
        },
        {
          id: 4,
          title: '开放式平台',
          subTitle: '区校本资源共建共享',
          hover: false,
          desc: '开放式平台，汇聚特色教学应用，区域资源共建共享，资源分发一触即达。'
        },
        {
          id: 5,
          title: '学情数据可视',
          subTitle: '智慧科学管理',
          hover: false,
          desc: '学情分析帮助教师精准教学，教学大数据助力区、校领导智慧管理，科学决策。'
        }
      ]
    }
  },
  methods: {
    getSrc: function (id) {
      return require('@/assets/images/home/advantage_' + id + '_bg.png')
    }
  }
}
</script>

<style scoped>
.its-advantage {
  padding-top: 91px;
  background-color: white;
  padding-bottom: 120px;
}

.its-advantage-title {
  color: black;
  font-size: 36px;
  text-align: center;
}

.its-advantage-list {
  margin-top: 73px;
  text-align: center;
}

.its-advantage-item {
  width: 200px;
  height: 360px;
  background-size: 100%;
  background-position: bottom center;
  background-repeat: no-repeat;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.30);
  border-radius: 10px;
  display: inline-block;
  padding-top: 78px;
  margin-left: 2px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.its-advantage-item-big {
  width: 380px;
  height: 500px;
  padding-top: 100px;
  top: 60px;
  margin-top: -60px;
}

.its-advantage-item p {
  text-align: center;
  margin-bottom: 13px;
  font-size: 20px;
  color: black;
}

.its-advantage-item-big>p {
  font-size: 24px;
  font-weight: normal;
  display: none;
}

.its-advantage-item-1 {
  background-image: url(../../../../assets/images/home/advantage_1_bg.png);
}

.its-advantage-item-big.its-advantage-item-1 {
  background-image: url(../../../../assets/images/home/advantage_1_bg_big.png);
}

.its-advantage-item-2 {
  background-image: url(../../../../assets/images/home/advantage_2_bg.png);
}

.its-advantage-item-big.its-advantage-item-2 {
  background-image: url(../../../../assets/images/home/advantage_2_bg_big.png);
}

.its-advantage-item-3 {
  background-image: url(../../../../assets/images/home/advantage_3_bg.png);
}

.its-advantage-item-big.its-advantage-item-3 {
  background-image: url(../../../../assets/images/home/advantage_3_bg_big.png);
}

.its-advantage-item-4 {
  background-image: url(../../../../assets/images/home/advantage_4_bg.png);
}

.its-advantage-item-big.its-advantage-item-4 {
  background-image: url(../../../../assets/images/home/advantage_4_bg_big.png);
}

.its-advantage-item-5 {
  background-image: url(../../../../assets/images/home/advantage_5_bg.png);
}

.its-advantage-item-big.its-advantage-item-5 {
  background-image: url(../../../../assets/images/home/advantage_5_bg_big.png);
}

.its-cover {
  background-color: rgba(0, 0, 0, 0.63);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 98px 42px 0 42px;
  color: white;
  font-size: 24px;
  line-height: 1.5;
  text-align: left;
}

.its-cover p {
  font-size: 24px;
  margin-bottom: 9px;
  color: white;
}
</style>